import React, { useEffect, useState } from "react";
import { Pagination, Table, Typography } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { ConnectedProps } from "react-redux";

import { getFileName, ordersColumns } from "../../../utils";
import UploadFileModal from "./UploadFile";
import InsuranceHomeHeader from "../Header";
import connector from "./Container";
import { CertifiedOrdersType } from "../../../models";

const Orders = ({ actions, state }: ConnectedProps<typeof connector>) => {
  const { orders, loading, certifiedOrders } = state;
  const [currentPage, setCurrentPage] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState<string>("");
  const pageSize = 10;

  useEffect(() => {
    actions.getOrders();
    actions.getCertifiedOrders();
  }, []);

  const currentData = certifiedOrders?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const orderDownload = (id: string) => {
    actions.downloadOrder(id);
  };

  const certifiedOrderDownload = (id: string, filename: string) => {
    actions.downloadCertifiedOrder(id, filename);
  };

  const handleOpenModal = (id: string) => {
    setSelectedOrderId(id);
    setModalVisible(true);
  };

  return (
    <div className="bg-white">
      <InsuranceHomeHeader />
      <div className="flex flex-1 flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 p-2">
          <Table
            columns={ordersColumns(handleOpenModal, orderDownload)}
            dataSource={orders}
          />
        </div>
        <div className="lg:w-4 lg:h-auto h-4 bg-base-gray"></div>
        <div className="w-full lg:w-1/2 px-6 py-2 lg:px-28">
          <Typography className="text-center font-bold text-lg my-8">
            PRETHODNO POSLANI NALOZI
          </Typography>
          <div className="flex-grow">
            {currentData?.map((item: CertifiedOrdersType) => (
              <div
                key={item.key}
                className="flex justify-between items-center mb-2 bg-light-gray px-2"
              >
                <div className="flex items-center">
                  <PaperClipOutlined className="opacity-45" />
                  <div
                    className="ml-2 text-primary cursor-pointer"
                    onClick={() =>
                      certifiedOrderDownload(
                        item.key.toString(),
                        getFileName(item.certifiedOrderFilePath)
                      )
                    }
                  >
                    {getFileName(item.certifiedOrderFilePath)}
                  </div>
                </div>
              </div>
            ))}
            {certifiedOrders?.length > 0 && (
              <div className="flex justify-center my-4">
                <Pagination
                  current={currentPage}
                  onChange={setCurrentPage}
                  total={certifiedOrders?.length}
                  pageSize={pageSize}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <UploadFileModal
        id={selectedOrderId}
        isVisible={modalVisible}
        isLoading={loading}
        handleClose={() => setModalVisible(false)}
        addCertifiedOrder={actions.addCertifiedOrder}
      />
    </div>
  );
};

export default Orders;
